import PropTypes from 'prop-types';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import SectionHeader from '../SectionHeader/SectionHeader';
import FaqItem from './FaqItem';

function Faq({ faq: { title, tagline, description, items } }) {
  return (
    <section id="faq" className="bg-gray-1000 py-5">
      <Container>
        <Row className="mb-5">
          <Col lg={8} className="offset-lg-2">
            <SectionHeader title={title} tagline={tagline} description={description} isDark />
          </Col>
        </Row>
        <Row>
          <Col lg={8} className="offset-lg-2">
            {items.map((faqItem) => (
              <FaqItem key={faqItem.id} title={faqItem.title} description={faqItem.description} />
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  );
}

Faq.propTypes = {
  faq: PropTypes.shape({}).isRequired,
};

export default Faq;
